"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var highcharts_gantt_1 = __importDefault(require("highcharts/highcharts-gantt"));
var react_resize_detector_1 = __importDefault(require("react-resize-detector"));
var utils_1 = require("../../utils");
var parts_1 = require("../parts");
var parts_2 = require("./parts");
/**
 * This component requires a commercial license. To find out more about licensing costs write an email to
 * [Martin Hlucka](mailto:Martin.Hlucka@honeywell.com)
 * @nonfree
 *
 * @child ./parts/Task/Task.tsx
 * @child ./parts/TaskGroup/TaskGroup.tsx
 * @child ./parts/Credits/Credits.ts
 * @child ./parts/Legend/Legend.ts
 * @child ./parts/RangeSelector/RangeSelector.ts
 * @child ./parts/Navigator/Navigator.ts
 * @child ./parts/Title/Title.ts
 * @child ./parts/Subtitle/Subtitle.ts
 * @child ./parts/Tooltip/Tooltip.ts
 * @child ./parts/XAxis/XAxis.ts
 * @child ./parts/YAxis/YAxis.ts
 *
 */
var Gantt = /** @class */ (function (_super) {
    __extends(Gantt, _super);
    function Gantt() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            headOptions: {},
            currentRange: {
                from: new Date(),
                to: new Date()
            },
            grouping: {
                type: '',
                count: 0,
                active: ''
            }
        };
        _this.debouncerTime = 100;
        _this.updateHead = function (headOptions) {
            var previousOptions = JSON.stringify(_this.state.headOptions);
            var nextOptions = JSON.stringify(headOptions);
            if (previousOptions !== nextOptions) {
                _this.setState({ headOptions: headOptions });
            }
        };
        _this.genClasses = function () {
            var _a = _this.props, className = _a.className, children = _a.children;
            var yAxis = utils_1.typeChildren(children).yAxis;
            var axisGrid = yAxis && yAxis[0] && yAxis[0].props.grid && yAxis[0].props.grid.enabled;
            var classes = 'ui forge chart-wrap gantt-chart';
            if (className) {
                classes += " " + className;
            }
            if (axisGrid) {
                classes += ' y-axis-grid';
            }
            return classes;
        };
        _this.handleResize = function (width, height) {
            var chart = _this.state.chart;
            var onResize = _this.props.onResize;
            if (chart && Object.keys(chart).length) {
                try {
                    chart.reflow();
                }
                catch (e) { }
                _this.forceUpdate();
            }
            if (onResize) {
                onResize(width, height);
            }
        };
        _this.updateGroupRange = function (grouping, range) {
            _this.setState({ grouping: grouping, currentRange: range });
        };
        _this.updateDebouncer = function (min, max) {
            clearTimeout(_this.debouncer);
            var grouping = {
                type: '',
                count: 0,
                active: ''
            };
            var range = {
                from: new Date(min),
                to: new Date(max)
            };
            _this.debouncer = setTimeout(function () {
                _this.updateGroupRange(grouping, range);
            }, _this.debouncerTime);
        };
        _this.composeOptions = function (initialRun) {
            var props = _this.props;
            var _a = utils_1.typeChildren(props.children), taskGroups = _a.taskGroups, xAxis = _a.xAxis, yAxis = _a.yAxis, legend = _a.legend, navigator = _a.navigator, tooltip = _a.tooltip, credits = _a.credits, rangeSelector = _a.rangeSelector, title = _a.title, subtitle = _a.subtitle;
            var base = utils_1.baseOptions(props, { navigator: navigator });
            var xAxisModifiers = { onSetExtremes: _this.updateDebouncer };
            var options = __assign(__assign({}, base), { series: parts_2.taskGroupOptions(taskGroups, initialRun), xAxis: parts_1.xAxisOptions(props, xAxis, xAxisModifiers), yAxis: parts_1.yAxisOptions(props, yAxis), legend: parts_1.legendOptions(props, legend), navigator: parts_1.navigatorOptions(props, navigator), tooltip: parts_1.tooltipOptions(props, tooltip), credits: parts_1.creditsOptions(credits) });
            var headOptions = {
                rangeSelector: parts_1.rangeSelectorOptions(props, rangeSelector),
                title: parts_1.titleOptions(props, title),
                subtitle: parts_1.subtitleOptions(props, subtitle)
            };
            return { options: options, headOptions: headOptions };
        };
        return _this;
    }
    Gantt.prototype.componentDidMount = function () {
        var _a = this.composeOptions(true), options = _a.options, headOptions = _a.headOptions;
        var chart = highcharts_gantt_1.default.ganttChart(this.highchartsRoot, options);
        var _b = chart.xAxis[0].getExtremes(), dataMin = _b.dataMin, dataMax = _b.dataMax;
        var currentRange = {
            from: new Date(dataMin),
            to: new Date(dataMax)
        };
        this.setState({ chart: chart, headOptions: headOptions, currentRange: currentRange });
    };
    Gantt.prototype.componentDidUpdate = function () {
        var _a = this.composeOptions(), options = _a.options, headOptions = _a.headOptions;
        this.updateHead(headOptions);
        this.state.chart.update(options, true, true);
    };
    Gantt.prototype.componentWillUnmount = function () {
        var chart = this.state.chart;
        if (chart) {
            chart.destroy();
        }
    };
    Gantt.prototype.render = function () {
        var _this = this;
        var _a = this.state, headOptions = _a.headOptions, currentRange = _a.currentRange, grouping = _a.grouping, chart = _a.chart;
        return (React.createElement("div", { className: this.genClasses() },
            chart && (React.createElement(parts_1.Head, __assign({}, headOptions, { chart: chart, currentRange: currentRange, grouping: grouping, updateGroupRange: this.updateGroupRange }))),
            React.createElement("div", { ref: function (ref) { return (_this.highchartsRoot = ref); } },
                React.createElement(react_resize_detector_1.default, __assign({ refreshMode: "throttle", refreshRate: 100, handleWidth: true, handleHeight: true, skipOnMount: false }, this.props.ResizerProps, { onResize: this.handleResize })))));
    };
    Gantt.defaultProps = {
        animation: true,
        showLegend: true,
        showNavigator: true,
        showRangeSelector: true,
        showTooltips: true,
        backgroundColor: '#FFFFFF00',
        colors: utils_1.defaultColors,
        dateTimeLabelFormats: utils_1.defaultDateTimeLabelFormats,
        chartType: 'gantt'
    };
    Gantt.Credits = parts_2.Credits;
    Gantt.Legend = parts_2.Legend;
    Gantt.Subtitle = parts_2.Subtitle;
    Gantt.Title = parts_2.Title;
    Gantt.Tooltip = parts_2.Tooltip;
    Gantt.XAxis = parts_2.XAxis;
    Gantt.YAxis = parts_2.YAxis;
    Gantt.TaskGroup = parts_2.TaskGroup;
    Gantt.Task = parts_2.Task;
    Gantt.RangeSelector = parts_2.RangeSelector;
    Gantt.Navigator = parts_2.Navigator;
    return Gantt;
}(React.Component));
exports.default = Gantt;
//# sourceMappingURL=Gantt.js.map